// Equalizes the height of review columns so the CSS multi-column masonry wraps evenly.
// Each review block is a <section class="reviews" id="..."> rendered by reviews.latte;
// this module finds them and re-balances on load and resize.

function getColumnCount(width) {
  if (width >= 1150) {
    return 3;
  }

  if (width >= 536) {
    return 2;
  }

  return 1;
}

function countColumns(itemHeights, col1Overhead, colOverhead, maxH) {
  let numCols = 1;
  let current = col1Overhead;

  for (let i = 0; i < itemHeights.length; i++) {
    if (current + itemHeights[i] > maxH) {
      numCols++;
      current = colOverhead;
    }

    current += itemHeights[i];
  }

  return numCols;
}

function resizeWrapper(wrapper) {
  const items = wrapper.getElementsByClassName('item');

  if (items.length === 0) {
    return;
  }

  wrapper.style.maxHeight = 'none';

  const numCols = getColumnCount(document.documentElement.clientWidth);

  if (numCols <= 1) {
    return;
  }

  const itemMargin = 20;
  const itemHeights = [];
  let totalItemHeight = 0;
  let maxItemHeight = 0;

  for (let i = 0; i < items.length; i++) {
    const h = Math.ceil(items[i].getBoundingClientRect().height) + itemMargin;
    itemHeights.push(h);
    totalItemHeight += h;

    if (h > maxItemHeight) {
      maxItemHeight = h;
    }
  }

  const wrapperTop = wrapper.getBoundingClientRect().top;
  const col1Overhead = Math.ceil(items[0].getBoundingClientRect().top - wrapperTop - 10);
  const colOverhead = Math.ceil(parseFloat(window.getComputedStyle(wrapper).paddingTop) || 0);

  let lo = Math.max(col1Overhead, colOverhead) + maxItemHeight;
  let hi = col1Overhead + totalItemHeight;

  while (lo < hi) {
    const mid = Math.floor((lo + hi) / 2);

    if (countColumns(itemHeights, col1Overhead, colOverhead, mid) <= numCols) {
      hi = mid;
    } else {
      lo = mid + 1;
    }
  }

  wrapper.style.maxHeight = (lo + 1) + 'px';
}

function resizeSectionReviewsHeight(sectionId) {
  const section = document.getElementById(sectionId);

  if (!section) {
    return;
  }

  const wrappers = section.getElementsByClassName('wrapper');

  for (let i = 0; i < wrappers.length; i++) {
    resizeWrapper(wrappers[i]);
  }
}

function recalcAllReviews() {
  const sections = document.querySelectorAll('section.reviews[id]');
  sections.forEach((section) => resizeSectionReviewsHeight(section.id));
}

recalcAllReviews();
setTimeout(recalcAllReviews, 500);
window.addEventListener('load', recalcAllReviews);
window.addEventListener('resize', () => {
  requestAnimationFrame(recalcAllReviews);
});
